import { slugFromEventsPath } from './events';
import { slugFromFeedbackPath } from '../components/forms/event-feedback';

/**
 * #4918/#4923 — resolve the dynamic /events routes. App.tsx matches `pages` by exact
 * path, so `/events/:slug` and `/events/:slug/feedback` need this prefix branch, or
 * they render the 404 page.
 */
export type EventsRoute = { kind: 'detail'; slug: string } | { kind: 'feedback'; slug: string };

export function resolveEventsRoute(pathname: string): EventsRoute | null {
  const feedbackSlug = slugFromFeedbackPath(pathname);
  if (feedbackSlug) return { kind: 'feedback', slug: feedbackSlug };
  const detailSlug = slugFromEventsPath(pathname);
  if (detailSlug) return { kind: 'detail', slug: detailSlug };
  return null;
}
